import { getContentRoute, webPid } from "./contentRoutes"
import { getImageURL } from "./images"

// the named entities catalog texts carry (Bulgarian quotes and dashes); numeric ones are decoded as such
const ENTITIES = { ndash: "–", mdash: "—", bdquo: "„", ldquo: "“", rdquo: "”", lsquo: "‘", rsquo: "’", sbquo: "‚", laquo: "«", raquo: "»", hellip: "…", middot: "·", bull: "•", copy: "©", reg: "®", trade: "™", euro: "€", deg: "°", times: "×", shy: "" }

// Strip HTML and truncate — works in SSR (no DOM)
export const sanitizeText = (text, maxLength = 200) => {
  if (!text) return ""
  let plain = String(text)
    .replace(/<style[\s\S]*?<\/style>/gi, "")
    .replace(/<script[\s\S]*?<\/script>/gi, "")
    .replace(/<!--[\s\S]*?-->/g, "")
    // a block ending (a paragraph, a line break, a heading) separates its words from the next ones
    .replace(/<\/?(p|br|div|li|ul|ol|h[1-6]|tr|td|blockquote|section|article)\b[^>]*>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&([a-z]+);/gi, (match, name) => (name.toLowerCase() in ENTITIES ? ENTITIES[name.toLowerCase()] : match))
    .replace(/&#(x[0-9a-f]+|[0-9]+);/gi, (match, code) => {
      const n = code[0].toLowerCase() === "x" ? parseInt(code.slice(1), 16) : parseInt(code, 10)
      return n > 0 && n < 0x110000 ? String.fromCodePoint(n) : match
    })
    .replace(/\s+/g, " ")
    .trim()
  if (plain.length <= maxLength) return plain
  return plain.substring(0, maxLength).trim() + "..."
}

/**
 * SEO fields for a product page in the shape AldooVikeHead consumes
 * (title, description, thumbnail, metadata.{ogType, canonicalUrl}).
 * Canonical is always https://aldoo.com/{book|album|product}/<slug>.<company>.
 */
/** The product's authors' names (the SSR product carries objects, the catalog strings), at most two. */
const authorNames = (product) =>
  (Array.isArray(product.author) ? product.author : [])
    .map((a) => (typeof a === "string" ? a : a?.name))
    .filter((name) => name && !/^[a-f0-9]{24}$/i.test(name))
    .slice(0, 2)

export function generateProductPageMeta(product) {
  if (!product?.pid) return null
  const route = getContentRoute(product)
  const description = product.description ? sanitizeText(product.description, 200) : "Listen, Read, Play"
  // the book and its author: what a search for "author + title" matches
  const authors = authorNames(product)
  return {
    title: product.name ? `${product.name}${authors.length ? ` – ${authors.join(", ")}` : ""} | Aldoo` : "Aldoo",
    description,
    thumbnail: getImageURL(product.square) || getImageURL(product.thumb) || undefined,
    metadata: {
      ogType: "book",
      canonicalUrl: `https://aldoo.com/${route}/${webPid(product.pid)}`,
    },
  }
}
